require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-golf-outing-raises-usd-23-000-for-charity.json") })
        }
      }, "path---es-articles-financial-center-golf-outing-raises-usd-23-000-for-charity");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-golf-outing-raises-usd-23-000-for-charity!./.cache/json/es-articles-financial-center-golf-outing-raises-usd-23-000-for-charity.json
// module id = 2143
// module chunks = 231608221292675